/**
 * Stilenza wishlist — het hartje op de productkaart.
 *
 * Stond eerst in stilenza-collection.js, en dat bestand wordt alleen door
 * sections/stilenza-collection.liquid geladen. De kaart zelf wordt op zes
 * plekken gerenderd: de collectiepagina, de homepage-grids, The Edit, de
 * zoekresultaten en twee keer op de productpagina. Op vijf daarvan stond er dus
 * een hartje dat niets deed als je erop drukte.
 *
 * Daarom staat het hier, en wordt het in de layout geladen: één plek, overal
 * hetzelfde gedrag.
 *
 * De lijst leeft in localStorage onder `stil-wishlist` (product handles). Bij
 * elke wijziging gaat er een `stilenza:wishlist-changed` de pagina in; de stip
 * in de header en de teller in de menu drawer luisteren daarop.
 */
(function () {
  'use strict';

  var KEY = 'stil-wishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* privémodus of vol quotum — de knop mag daar niet op stukvallen */
    }
    document.dispatchEvent(new CustomEvent('stilenza:wishlist-changed', {
      detail: { count: list.length }
    }));
  }

  // Zet de al opgeslagen hartjes aan. Draait ook opnieuw nadat een filter of een
  // "meer laden" nieuwe kaarten in de DOM heeft gezet.
  function sync() {
    var list = read();
    document.querySelectorAll('[data-card-wishlist]').forEach(function (btn) {
      btn.classList.toggle('is-active', list.indexOf(btn.dataset.cardWishlist) !== -1);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-card-wishlist]');
    if (!btn) return;
    // De kaart is zelf een link; zonder dit navigeer je weg bij het opslaan.
    e.preventDefault();
    e.stopPropagation();

    var handle = btn.dataset.cardWishlist;
    var list = read();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
      btn.classList.add('is-active');
    } else {
      list.splice(idx, 1);
      btn.classList.remove('is-active');
    }
    write(list);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  document.addEventListener('stilenza:products-updated', sync);
  // Ander tabblad, zelfde winkel: houd de hartjes gelijk.
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) sync();
  });

  window.stilWishlistSync = sync;
})();
